import { useEffect } from 'react';
import { rage } from '~/rage';
import { Background } from '../../components/Background';
import { useLayoutSelector } from '../../redux/hooks';
import { PromoAdd } from '../PromoAdd';
import { PromoList } from '../PromoList';

const Promo: React.FC = () => {
	const currentView = useLayoutSelector((state) => state.promo.currentView);

	useEffect(() => {
		rage.input
			.setAnyInputFocused(true)
			.catch((err) => rage.notifications.showException(err));

		return () => {
			rage.input
				.setAnyInputFocused(false)
				.catch((err) => rage.notifications.showException(err));
		};
	}, []);

	return (
		<>
			<Background />
			{currentView === 'add' ? <PromoAdd /> : <PromoList />}
		</>
	);
};

export { Promo as PromoLayout };
